export enum ClassToggleAttr {
  TRIGGER = 'data-js-toggle-trigger',
  ITEM = 'data-js-toggle-item',
  CLASS = 'data-js-toggle-class',
  GROUP = 'data-js-toggle-group',
  // Deprecated
  TRIGGER_DEPRECATED = 'js-toggle-trigger',
  ITEM_DEPRECATED = 'js-toggle-item',
  CLASS_DEPRECATED = 'js-toggle-class',
  GROUP_DEPRECATED = 'js-toggle-group',
}
